import { usePendingLegalDocuments } from '@api/hooks/useLegalDocuments';
import { Loader } from '@gurupay/gp-ui-library';
import type { ReactNode } from 'react';
import { lazy, Suspense } from 'react';

import { useAuth } from '../hooks';
import { useCookiesBanner } from '../hooks/useCookieBanner';
import { useLoginRedirectRestore } from '../hooks/useLoginRedirectRestore';

const LazyLegalConsentScreen = lazy(() =>
	import('@components/LegalConsent').then(({ LegalConsentScreen }) => ({
		default: LegalConsentScreen,
	})),
);

const pageLoader = (
	<div className="h-screen flex items-center justify-center">
		<Loader />
	</div>
);

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
	const { session } = useAuth();
	const { documents, isChecking } = usePendingLegalDocuments();
	useCookiesBanner(session);
	useLoginRedirectRestore(!!session);

	if (!session) {
		return null;
	}

	if (isChecking) {
		return pageLoader;
	}

	if (documents.length) {
		return (
			<Suspense fallback={pageLoader}>
				<LazyLegalConsentScreen documents={documents} />
			</Suspense>
		);
	}
	return children;
};

export default ProtectedRoute;
